// Self-hosted telemetry. Opt-in: nothing fires until the user enables it.
// All events go to our own backend — no third-party trackers, no ads.
import { api } from './api/client';
const OPTIN_KEY = 'plunder.telemetry_optin';
const CLIENT_ID_KEY = 'plunder.telemetry_client_id';
let cachedClientId = null;
export function isTelemetryEnabled() {
    try {
        return localStorage.getItem(OPTIN_KEY) === '1';
    }
    catch {
        return false;
    }
}
export function setTelemetryEnabled(on) {
    try {
        if (on)
            localStorage.setItem(OPTIN_KEY, '1');
        else
            localStorage.removeItem(OPTIN_KEY);
    }
    catch {
        // ignore — private mode etc.
    }
}
function getOrCreateClientId() {
    if (cachedClientId)
        return cachedClientId;
    try {
        let id = localStorage.getItem(CLIENT_ID_KEY);
        if (!id) {
            id = (typeof crypto !== 'undefined' && crypto.randomUUID)
                ? crypto.randomUUID()
                : Math.random().toString(36).slice(2) + Date.now().toString(36);
            localStorage.setItem(CLIENT_ID_KEY, id);
        }
        cachedClientId = id;
        return id;
    }
    catch {
        return 'anon';
    }
}
export function track(event, payload) {
    if (!isTelemetryEnabled())
        return;
    const client_id = getOrCreateClientId();
    // Fire-and-forget — never await, never surface errors.
    api.telemetry(event, payload, client_id).catch(() => { });
}
